



































import {
  Component,
  Vue
} from "@/shared/vuepack";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  FetchState,
  ManagedExpenseFilterType
} from "@/shared/types";
import HsabExpenseCardRow from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRow.vue";
import ActionNeededExpenseWidgetRow from "@/employee/components/hsabExpenses/ActionNeededExpenseWidgetRow.vue";
import * as RouteNames from "@/employee/route-names";

@Component({
  computed: {
    FetchState () {
      return FetchState;
    }
  },
  components: { ActionNeededExpenseWidgetRow, HsabExpenseCardRow, GenericLoadingSpinner }
})
export default class ActionNeededExpensesWidget extends Vue {
  managedExpenseStore = useManagedExpenseStore();
  RouteNames = RouteNames;

  created () {
    this.managedExpenseStore.loadActionNeededPreview();
  }

  navigateToActionNeeded () {
    this.$router.push({ name: RouteNames.HsabExpenseManagement, params: { filter: ManagedExpenseFilterType.ActionNeeded } });
  }
}
